export default __webpack_public_path__ + "static/media/lezioni-in-corso-nc.6d2ad504.svg";